<!-- CardEdit -->
<template>
  <!-- v-bind="$attrs" 传入card-edit中的 attributes -->
  <a-form :form="form" v-if="schema && sourceData" v-bind="$attrs">
    <a-row :gutter="gutter">
      <a-col
        v-for="item in infoList"
        :key="item.key"
        :xs="item.xs || defaultColXs || 24"
        :sm="item.sm || defaultColSm || 24"
        :md="item.md || defaultColMd || 12"
        :lg="item.lg || defaultColLg || 8"
        :xl="item.xl || defaultColXl || 8"
      >
        <a-form-item>
          <!-- label -->
          <template slot="label">
            {{ item.label }}
            <!-- 带说明浮框 -->
            <a-tooltip v-if="item.showTooltip">
              <template slot="title">
                {{ item.tooltip }}
              </template>
              <a-icon :type="item.tooltipIcon || 'question-circle'" />
            </a-tooltip>
          </template>

          <!-- 自定义具名slot -->
          <template v-if="item.slotName">
            <slot :name="item.slotName" :item="item"></slot>
          </template>

          <!-- 根据type显示对应组件 -->
          <!-- text,只读 -->
          <template v-else-if="item.type === 'text'">
            <span>{{ item.value }}</span>
          </template>

          <!-- Input -->
          <template v-else-if="item.type === 'input'">
            <a-input
              :placeholder="item.placeholder || '请输入'"
              :maxLength="item.maxLength"
              :disabled="item.disabled"
              :allowClear="item.allowClear || false"
              :has-feedback="item.hasFeedback"
              :size="size"
              v-decorator="[
                item.key,
                {
                  initialValue: item.value,
                  rules: item.rules || [],
                  getValueFromEvent: event => handleInputChange(event, item),
                },
              ]"
            />
             
          </template>

          <!-- Select -->
          <template v-else-if="item.type === 'select'">
            <a-select
              :mode="item.mode"
              :size="size"
              :disabled="item.disabled"
              :allowClear="item.allowClear"
              :placeholder="item.placeholder || '请选择'"
              :show-search="item.showSearch"
              :option-filter-prop="item.optionFilterProp || 'children'"
              :filter-option="item.filterOption"
              @search="value => handleSelectSearch(value, item)"
              @change="value => handleSelectChange(value, item)"
              v-decorator="[
                item.key,
                {
                  initialValue: item.value,
                  rules: item.rules,
                },
              ]"
            >
              <a-select-option
                v-for="optionItem in item.optionList"
                :value="optionItem[(item.fieldNames || fieldNames).value]"
                :key="optionItem[(item.fieldNames || fieldNames).value]"
                :disabled="optionItem.disabled"
              >
                {{ optionItem[(item.fieldNames || fieldNames).label] }}
              </a-select-option>
            </a-select>
          </template>

          <!--无自定义方法-->

          <template v-else-if="item.type === 'selectmode'">
            <a-select
              :mode="item.mode"
              :size="size"
              :disabled="item.disabled"
              :allowClear="item.allowClear"
              :placeholder="item.placeholder || '请选择'"
              :show-search="item.showSearch"
              :option-filter-prop="item.optionFilterProp || 'children'"
              :filter-option="item.filterOption"
              @search="value => handleSelectSearch(value, item)"
              @change="value => handleSelectChange(value, item)"
              v-decorator="[
                item.key,
                {
                  initialValue: item.value,
                  rules: item.rules,
                },
              ]"
            >
              <a-select-option
                v-for="optionItem in item.optionList"
                :value="optionItem.id"
                :key="optionItem.id"
                :disabled="optionItem.disabled"
              >
                {{ optionItem.name }}
              </a-select-option>
            </a-select>
          </template>
          <!-- DatePicker -->
          <template v-else-if="item.type === 'datePicker'">
            <a-date-picker
              :size="size"
              :disabled="item.disabled"
              :allowClear="item.allowClear"
              :showTime="item.showTime"
              :placeholder="item.placeholder"
              v-decorator="[
                item.key,
                {
                  initialValue: momentWrapDate(item.value, item.dateFormat),
                  rules: item.rules,
                },
              ]"
            />
          </template>

          <!-- RangePicker -->
          <template v-else-if="item.type === 'rangePicker'">
            <a-range-picker
              :size="size"
              :disabled="item.disabled"
              :allowClear="item.allowClear"
              :placeholder="item.placeholder"
              v-decorator="[
                item.key,
                {
                  initialValue: getRangePickerValue(
                    item.value,
                    item.dateFormat,
                  ),
                },
              ]"
            />
          </template>

          <!-- Cascader -->
          <template v-else-if="item.type === 'cascader'">
            <a-cascader
              :disabled="item.disabled"
              :allowClear="item.allowClear"
              :size="size"
              :placeholder="item.placeholder || '请选择'"
              :options="item.optionList"
              :field-names="
                item.fieldNames || {
                  label: 'label',
                  value: 'value',
                  children: 'children',
                }
              "
              v-decorator="[
                item.key,
                {
                  initialValue: item.value,
                },
              ]"
            />
          </template>
        </a-form-item>
      </a-col>
      <!-- 默认slot -->
      <slot></slot>
    </a-row>

    <!-- 操作区域 -->
    <slot name="operate-area"></slot>
  </a-form>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      name: 'CardEdit',
      form: this.$form.createForm(this, {
        name: this.formName,
      }),
    }
  },
  props: {
    formName: {
      type: String,
      default: 'cardEditForm',
    },
    schema: {
      type: Object,
      // required: true,
      default: function() {
        return {}
      },
    },
    sourceData: {
      type: Object,
      // required: true,
      default: function() {
        return {}
      },
    },
    // 控件大小。可以设置为 large、default 、small
    size: {
      type: String,
      default: 'default',
      validator: function(value) {
        // 这个值必须匹配下列字符串中的一个
        const checkStatus = ['default', 'large', 'small'].indexOf(value) !== -1
        if (!checkStatus) {
          console.error('size必须为 default| large | small中的一个')
        }
        return checkStatus
      },
    },
    //栅格间隔，可以写成像素值或支持响应式的对象写法来设置水平间隔 { xs: 8, sm: 16, md: 24}。或者使用数组形式同时设置 [水平间距, 垂直间距]（1.5.0 后支持）。
    gutter: {
      type: [Number, Object, Array],
      default: 0,
    },

    // 设置默认 <576px 时响应式栅格，可为栅格数或一个包含其他属性的对象
    defaultColXs: {
      type: [Number, Object],
      default: 24,
    },

    // 设置默认 ≥576px 时响应式栅格，可为栅格数或一个包含其他属性的对象
    defaultColSm: {
      type: [Number, Object],
      default: 24,
    },

    // 设置默认 ≥768px 时响应式栅格，可为栅格数或一个包含其他属性的对象
    defaultColMd: {
      type: [Number, Object],
      default: 12,
    },

    // 设置默认 ≥992 时响应式栅格，可为栅格数或一个包含其他属性的对象
    defaultColLg: {
      type: [Number, Object],
      default: 8,
    },

    // 设置默认 ≥1200px 时响应式栅格，可为栅格数或一个包含其他属性的对象
    defaultColXl: {
      type: [Number, Object],
      default: 8,
    },

    fieldNames: {
      type: Object,
      default: function() {
        return { label: 'label', value: 'value' }
      },
    },
  },
  computed: {
    infoList() {
      return this.schema2ListBySourceData(this.sourceData, this.schema)
    },
  },
  methods: {
    schema2ListBySourceData(sourceData, SCHEMA) {
      if (!sourceData || !SCHEMA) {
        return []
      }
      const keys = Object.keys(SCHEMA)
      let list = []
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (sourceData[key] != undefined) {
          // 在sourceData中有key对应值才放入list
          SCHEMA[key].value = sourceData[key]
          SCHEMA[key].key = key
          list.push(SCHEMA[key])
        }
      }
      return list
    },

    // 暴露给父组件的方法，修改form里的值
    setFormFieldsValue(key, value) {
      this.form.setFieldsValue({
        [key]: value,
      })
    },

    // 暴露给父组件的方法，提交表单
    async handleSubmit() {
      try {
        const validateResult = await this.form.validateFields()
        return Promise.resolve(validateResult)
      } catch (error) {
        console.error('校验未通过')
      }
    },

    // 暴露给父组件的方法，重置表单
    handleReset() {
      this.form.resetFields()
    },

    // 暴露给父组件的方法，获取未通过的校验
    getFieldsError() {
      return this.form.getFieldsError()
    },
    // 暴露给父组件的方法，滑动至未通过校验区域
    scrollToError() {
      const fieldsError = this.getFieldsError()
      this.form.validateFieldsAndScroll(Object.keys(fieldsError))
    },
    // 暴露给父组件的方法，滚动至某项未通过校验处
    scrollToErrorBykey(key) {
      this.form.validateFieldsAndScroll([key], {
        scroll: {
          alignWithTop: true,
          onlyScrollIfNeeded: false,
        },
      })
    },

    // ----------------------Input相关方法---------------------
    handleInputChange(event, item) {
      const { value } = event.target
      const handleInputCheck = item.handleInputCheck
      let newValue = ''
      if (typeof handleInputCheck === 'function') {
        newValue = handleInputCheck(value)
      } else if (this[handleInputCheck]) {
        newValue = this[handleInputCheck](value)
      } else {
        newValue = value
      }
      return newValue
    },
    // 限制两位小数的输入
    checkFloat2(newValue) {
      const regFloat_2 = /^\d*(\.?\d{0,2})/g
      return (newValue.match(regFloat_2) && newValue.match(regFloat_2)[0]) || ''
    },
    // 限制输入正整数,且第一位非0
    checkPositiveInt(newValue) {
      const reg1st_not0 = /^[0]|[1-9][0-9]*/g
      return (
        (newValue.match(reg1st_not0) && newValue.match(reg1st_not0)[0]) || ''
      )
    },

    // ----------------------Select相关方法----------------------
    handleSelectSearch(value, item) {
      item.search && this.$emit(item.search, value)
    },
    handleSelectChange(value, item) {
      item.emit && this.$emit(item.emit, value)
    },

    // ----------------------DatePicker相关方法----------------------
    moment,
    momentWrapDate(value, dateFormat) {
      if (value) {
        return this.moment(value, dateFormat || 'YYYY-MM-DD')
      }
      return null
    },
    getRangePickerValue(values, dateFormat) {
      if (values.every(value => !value)) {
        return null
      }
      return values.map(value => this.momentWrapDate(value, dateFormat))
    },

    // ---------------------Cascader相关方法----------------------
  },
}
</script>

<style scoped>
.ant-form-item label > .anticon {
  vertical-align: middle;
}
.ant-calendar-picker {
  width: 100%;
}
</style>
